import { Button } from '@artosera/ui';
import { Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useCreerCampagne, type CampagneNewsletter } from '../../api/newsletter.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ErreurNewsletter } from './ErreurNewsletter.js';
/**
 * Duplique une campagne en nouveau brouillon : le serveur n'a pas de route
 * dédiée, mais la création accepte déjà titre, sujet, langue, listes et blocs.
 */
export function BoutonDupliquer({ campagne }: { campagne: CampagneNewsletter }) {
  const { t } = useTranslation('regie');
  const { galerieSlug, galerie } = useShellContext();
  const creer = useCreerCampagne(galerieSlug);
  const navigate = useNavigate();
  if (!galerieALaction(galerie, 'newsletter:write')) return null;
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        disabled={creer.isPending}
        aria-label={t('newsletter.campagnes.dupliquerNom', { titre: campagne.titre })}
        onClick={() => {
          creer.mutate(
            {
              titre: t('newsletter.campagnes.copieDe', { titre: campagne.titre }).slice(0, 200),
              sujet: campagne.sujet,
              langue: campagne.langue,
              listes: campagne.listes,
              blocs: campagne.blocs,
            },
            {
              onSuccess: ({ campagne: copie }) => {
                void navigate(`/${galerieSlug}/newsletter/campagnes/${copie.id}`);
              },
            },
          );
        }}
      >
        <Copy size={16} aria-hidden="true" />
        {t('newsletter.campagnes.dupliquer')}
      </Button>
      <ErreurNewsletter erreur={creer.error} />
    </>
  );
}
